import React, { useState } from "react";

const PasswordInput = ({ value, onChange, placeholder, onKeyPress }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="passwordinput">
      <input
        type={showPassword ? "text" : "password"}
        name="password"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{ width: "-webkit-fill-available" }}
        onKeyPress={onKeyPress}
      />
      <div onClick={togglePasswordVisibility}>
        {showPassword ? (
          <i className="fas fa-eye"></i>
        ) : (
          <i className="fas fa-eye-slash"></i>
        )}
      </div>
    </div>
  );
};

export default PasswordInput;
